module.exports = __webpack_public_path__ + "static/media/24UHCHR14.a0cb72f9.jpg";